(ns frontend.view.grid.holdings-grid.db
  (:require [frontend.db :as app-db]
            [reagent.core :as r]))

(defonce holdings (r/cursor app-db/views [:holdings]))
(defonce modal-state (r/cursor holdings [:modals]))
(defonce grid-entities (r/cursor holdings [:grid-entities]))
(defonce view-settings (r/cursor holdings [:view-settings]))
(defonce holding-filters (r/cursor view-settings [:filters]))
(defonce selected-columns (r/cursor view-settings [:selected-columns]))
(defonce column-widths (r/cursor view-settings [:column-widths]))
(defonce ordered-columns (r/cursor view-settings [:ordered-columns]))

(defonce kanban (r/cursor holdings [:kanban]))
(defonce expanded (r/cursor kanban [:expanded]))
(defonce grouped-by (r/cursor view-settings [:grouped-by]))
(defonce card-settings (r/cursor view-settings [:card-settings]))
(defonce lists (r/cursor kanban [:lists]))
(defonce sorted-kanban-entities (r/cursor holdings [:sorted-kanban-entities]))

;;precalculated schema (for performance reasons):
(defonce schema (r/cursor holdings [:schema]))
